export default "__VITE_ASSET__ivp5BULZ__"